module.exports = __webpack_public_path__ + "static/media/cow-with-cap.35656abd.gif";